// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KkZHG3JrQjRLOVPmdUgm {
	align-items: center;
	display: flex;
	justify-content: space-between;
}

.KkZHG3JrQjRLOVPmdUgm:first-child {
    margin-top: 10px;
}

.KkZHG3JrQjRLOVPmdUgm:not(:last-child) {
    border-bottom: 1px solid rgba(255,255,255, .2);
    padding-bottom: 8px;
    margin-bottom: 8px;
}

.il691mh5NswALMa3YXhZ {
    color: #fff;
    font-family: inherit;
    font-weight: 400;
    font-size: 24px;
    line-height: 32px;
    letter-spacing: -0.08em;
}

.As5ARWh8PmJhP5yJg8uV {
    box-sizing: border-box;
    font-size: 16px;
    letter-spacing: -0.08em;
    line-height: 28px;
    padding: 4px 26.5px;
    height: 36px;
}`, "",{"version":3,"sources":["webpack://./src/pages/ClaimRewardsPage/BannersVesisHolder/BannerClaim/BannerClaim.pcss"],"names":[],"mappings":"AAAA;CACC,mBAAmB;CACnB,aAAa;CACb,8BAA8B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,8CAA8C;IAC9C,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;AAChB","sourcesContent":[".bannerClaimRow {\n\talign-items: center;\n\tdisplay: flex;\n\tjustify-content: space-between;\n}\n\n.bannerClaimRow:first-child {\n    margin-top: 10px;\n}\n\n.bannerClaimRow:not(:last-child) {\n    border-bottom: 1px solid rgba(255,255,255, .2);\n    padding-bottom: 8px;\n    margin-bottom: 8px;\n}\n\n.bannerClaimSum {\n    color: #fff;\n    font-family: inherit;\n    font-weight: 400;\n    font-size: 24px;\n    line-height: 32px;\n    letter-spacing: -0.08em;\n}\n\n.claimButton {\n    box-sizing: border-box;\n    font-size: 16px;\n    letter-spacing: -0.08em;\n    line-height: 28px;\n    padding: 4px 26.5px;\n    height: 36px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bannerClaimRow": `KkZHG3JrQjRLOVPmdUgm`,
	"bannerClaimSum": `il691mh5NswALMa3YXhZ`,
	"claimButton": `As5ARWh8PmJhP5yJg8uV`
};
export default ___CSS_LOADER_EXPORT___;
